import React, { useEffect } from 'react';
import { Content, PreloaderWrapper, ScrollOffset, Wrapper } from './verification-page.styles';
import { useVerifyEmailMutation } from '@features/user/register/api/register-api';
import { Typography } from '@shared/ui/typography/typography';
import { getQueryError } from '@shared/lib/utils/get-query-error/get-query-error';
import { Preloader } from '@vtbhome/juicyfront';
import { useVerificationCode } from '../lib/use-verification-code';
import { Redirect } from 'react-router-dom';
import { ROUTE_AUTH } from '@shared/config/routes/routes';
import { VerificationSuccess } from './verification-success/verification-success';
import { VerificationError } from './verification-error/verification-error';

export const VerificationPage: React.FC = () => {
    const [emailVerify, emailVerifyResult] = useVerifyEmailMutation();
    const verificationError = getQueryError(emailVerifyResult);
    const code = useVerificationCode();

    useEffect(() => {
        if (code) {
            emailVerify({ code });
        }
    }, [location.search]);

    if (!code) {
        return <Redirect to={ROUTE_AUTH} />;
    }

    return (
        <Wrapper>
            <Content>
                <ScrollOffset>
                    {emailVerifyResult.isLoading && (
                        <>
                            <PreloaderWrapper>
                                <Preloader size='l' />
                            </PreloaderWrapper>
                            <Typography size='body1_short' align='center'>
                                Подтверждение email
                            </Typography>
                        </>
                    )}
                    {verificationError && <VerificationError error={verificationError.message} />}
                    {emailVerifyResult.isSuccess && <VerificationSuccess response={emailVerifyResult.data} />}
                </ScrollOffset>
            </Content>
        </Wrapper>
    );
};
